import type {CandidateEvaluationWithRecruiterHubAction} from 'src/action-creators/candidate-evaluation-with-recruiter-hub';
import type {CandidateEvaluationWithRecruiterHubState} from 'src/types/candidate-evaluation-with-recruiter-hub';
import {getDefaultNodeScheduleState} from 'src/utils/node-schedule';
import {
  RECEIVE_CANDIDATE_EVALUATION_WITH_RECRUITER_HUB_INFO,
  UPDATE_CANDIDATE_EVALUATION_WITH_RECRUITER_HUB_INFO,
  UPDATE_NODE_SCHEDULE_WITH_RECRUITER_HUB,
  RESET_CANDIDATE_EVALUATION_WITH_RECRUITER_HUB_INFO,
} from 'src/action-creators/candidate-evaluation-with-recruiter-hub';


const initialState = {
  transcript: null,
  transcript_source: 'voice_ai_call',
  conversation_id: null,
  job_id: null,
  job_title: null,
  job_description: null,
  recipient_entity_id: null,
  resume: null,
  rh_enabled: true,
  ...getDefaultNodeScheduleState({}),
} as const;

export default (
  state: CandidateEvaluationWithRecruiterHubState = initialState,
  action: CandidateEvaluationWithRecruiterHubAction,
): CandidateEvaluationWithRecruiterHubState => {
  switch (action.type) {
    case RECEIVE_CANDIDATE_EVALUATION_WITH_RECRUITER_HUB_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_CANDIDATE_EVALUATION_WITH_RECRUITER_HUB_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_NODE_SCHEDULE_WITH_RECRUITER_HUB:
      return {
        ...state,
        ...action.payload,
      };
    case RESET_CANDIDATE_EVALUATION_WITH_RECRUITER_HUB_INFO:
      return {...initialState};
  }
  return state;
};
